import React, { ReactNode, useState, useContext, createContext } from 'react';

type MyComponentProps = {
  value: string;
  user: any;
  snackbar: object;
  isAuthenticated: boolean;
  setFields: React.Dispatch<React.SetStateAction<any>>;
};

const SkyContext = createContext<MyComponentProps | undefined>(undefined);

// const SkyContext = React.createContext<{
//   value: string;
//   setValue: React.Dispatch<React.SetStateAction<string>>;
// }|null>(null);
//   const SkyContext = React.createContext(null);

export function useSkyContext() {
  const context = useContext(SkyContext);
  if (context === undefined) {
    throw new Error('useMyContext must be used within a MyContextProvider');
  }
  return context;
}

// Create a context provider component
export function Provider({ children }: { children: React.ReactNode }) {
  // Initialize the state with default values
  const [fields, setFields] = useState<any>({
    value: '',
    user: null,
    snackbar: null,
    isAuthenticated: false,
  });

  return (
    <SkyContext.Provider value={{ ...fields, setFields }}>
      {children}
    </SkyContext.Provider>
  );
}
